<template>
  <div>
    <el-row :gutter="0" class="layout-row">
      <el-col :span="4" class="layout-col">
        <!-- 左侧菜单栏 -->
        <LeftMenu />
      </el-col>
      <el-col :span="20" class="layout-col layout-right">
        <transition name="fold-left">
          <!-- 头部 -->
          <div class="view">
            <PageHeader />
            <router-view class="app-view"></router-view>
          </div>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import LeftMenu from "../../components/layout/left-menu.vue";
import PageHeader from "../../components/layout/page-header.vue";
export default {
  data() {
    return {};
  },
  components: {
    LeftMenu,
    PageHeader,
  },
  mounted() {},
};
</script>

<style scoped>
.layout-row {
  flex: 1;
  overflow: hidden;
}
.layout-col {
  height: 100%;
  overflow: hidden;
}
.layout-right {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.view {
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}
</style>